
import React from 'react';

export const EditIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    edit
  </span>
);